"use client";
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { Icon } from '../../Icon/Icon.web.js';

var _excluded = ["color", "size"];
var IconApartment = function IconApartment(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === undefined ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    sizeProp = _ref$size === undefined ? '48px' : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded);
  var size = sizeProp;
  return /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
    fill: "none",
    viewBox: "0 0 48 48",
    width: size,
    height: size
  }, /*#__PURE__*/React.createElement("path", {
    fill: color,
    fillRule: "evenodd",
    d: "M10 23.377v20.119a24 24 0 0 1-2-1.607v-17.71l-2 .795v-6.17l5-2.014V12h3v3.582l5-2.015V9h3v3.358l2-.805V7h3v3.344l12-4.835V24h2v6h-2v8h2v2.941A24 24 0 0 1 37.271 44H34v1.824q-.978.45-2 .81V14.482zM34 26v2h5v-2zm0 4v8h3v-8zm0-6V13.678l3-1.194V24zm-8-13.253V8h-1v3.15zm-5 2.014V10h-1v3.164zm-8 3.224V13h-1v3.387zM8.063 22l.272-.107L32 12.325v-.003l.63-.251.922-.373L37 10.331v-1.86L8 20.153V22zM39 42h-5v-2h5zM23 25v6h4v-6zm3 1v4h-2v-4zm-12-1h4v6h-4zm3 5v-4h-2v4zm6 5v6h4v-6zm3 1v4h-2v-4zm-12-1h4v6h-4zm3 5v-4h-2v4z",
    clipRule: "evenodd"
  })));
};

export { IconApartment, IconApartment as default };
